module.exports = __webpack_public_path__ + "files/c817007e9a93a5d6920798ef96dd751d.svg";